module.exports = __webpack_public_path__ + "img/殷文聪.e342e46e.jpg";